import React from "react";

export default function CentrosTable({
  centros,
  loading,
  listError,
  loadCentros,
  canCreateCentro,
  canUpdateCentro,
  canDeleteCentro,
  abrirModalNuevo,
  abrirModalEditar,
  abrirModalEliminar,
}) {
  const totalCentros = centros.length;
  const canManageCentros = canUpdateCentro || canDeleteCentro;

  const renderContent = () => {
    if (loading) {
      return (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Cargando...</span>
          </div>
        </div>
      );
    }

    if (listError) {
      return (
        <div className="text-center py-4">
          <p className="text-muted mb-3">{listError}</p>
          <button className="btn management-btn-primary" onClick={loadCentros}>
            Reintentar
          </button>
        </div>
      );
    }

    if (!centros.length) {
      return (
        <div className="dashboard-empty text-center py-5">
          <i className="bi bi-inboxes dashboard-empty-icon mb-3"></i>
          <h5 className="fw-semibold mb-1">Aun no hay centros registrados</h5>
          <p className="mb-3">Comienza creando el primero para visualizarlo aqui.</p>
          {canCreateCentro && (
            <button type="button" className="btn management-btn-primary" onClick={abrirModalNuevo}>
              Crear centro
            </button>
          )}
        </div>
      );
    }

    return (
      <div className="management-table-wrapper table-responsive">
        <table className="table align-middle management-table centros-table mb-0">
          <thead>
            <tr>
              <th>#</th>
              <th>Nombre</th>
              <th>RUC</th>
              <th>Direccion</th>
              <th>Telefono</th>
              <th>Email</th>
              <th>Estado</th>
              <th className="text-center">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {centros.map((centro, index) => (
              <tr key={centro.id}>
                <td>{index + 1}</td>
                <td>{centro.nombre || "-"}</td>
                <td>{centro.ruc || "-"}</td>
                <td>{centro.direccion || "-"}</td>
                <td>{centro.telefono || "-"}</td>
                <td>{centro.email || "-"}</td>
                <td>
                  <span
                    className={`badge rounded-pill dashboard-status ${
                      centro.activo ? "success" : "muted"
                    }`}
                  >
                    {centro.activo ? "Activo" : "Inactivo"}
                  </span>
                </td>
                <td className="text-center">
                  {canManageCentros ? (
                    <div className="d-flex justify-content-center gap-2">
                      {canUpdateCentro && (
                        <button
                          type="button"
                          className="btn btn-icon dashboard-icon-button management-action-btn"
                          title="Editar"
                          onClick={() => {
                            if (canUpdateCentro) abrirModalEditar(centro);
                          }}
                        >
                          <i className="bi bi-pencil-square"></i>
                        </button>
                      )}
                      {canDeleteCentro && (
                        <button
                          type="button"
                          className="btn btn-icon dashboard-icon-button warning management-action-btn"
                          title="Eliminar"
                          onClick={() => {
                            if (canDeleteCentro) abrirModalEliminar(centro);
                          }}
                        >
                          <i className="bi bi-trash"></i>
                        </button>
                      )}
                    </div>
                  ) : (
                    <span className="text-muted small">Sin permisos</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="management-card centros-table-card">
      <div className="d-flex flex-wrap gap-3 justify-content-between align-items-center mb-3">
        <div>
          <p className="management-label mb-1">Listado general</p>
          <h5 className="mb-0">Centros de capacitacion</h5>
        </div>
        <span className="management-pill">
          <i className="bi bi-buildings" />
          {totalCentros} centros
        </span>
      </div>
      {renderContent()}
    </div>
  );
}
